// extracted by mini-css-extract-plugin
export var blogFirst = "index-module--blogFirst--9AV2w";
export var blogList = "index-module--blogList--MH3Ig";
export var desc = "index-module--desc--ldpGq";
export var ellipsis = "index-module--ellipsis--EAGDH";
export var firstDesc = "index-module--firstDesc--bc5Ws";
export var more = "index-module--more--NgmW1";
export var name = "index-module--name--78AYF";